import { Resource, StickersConfig } from '@yandex-int/k-common';

import { ResourceId } from '../typings';

export const getResourceBySlug = (
    slug: string,
    stickersConfig: StickersConfig,
    resources: Record<ResourceId, Resource>
) => {
    const stickerItem = stickersConfig.find((item) => item.slug === slug);
    if (!stickerItem) {
        return null;
    }
    const resource = resources[stickerItem.resource_id];
    if (!resource) {
        return null;
    }
    return resource;
};
